const JWT_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
const JWT_EXP_REFRESH_BUFFER_SECONDS = 30;

const parseJwtPayload = token => {
  const normalizedToken = normalizeAccessToken(token);

  if (!normalizedToken) {
    return null;
  }

  try {
    const [, payload] = normalizedToken.split('.');
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
  } catch (error) {
    return null;
  }
};

export const normalizeAccessToken = rawToken => {
  if (typeof rawToken !== 'string') {
    return null;
  }

  const trimmedToken = rawToken.trim();
  if (!trimmedToken) {
    return null;
  }

  const tokenValue = trimmedToken.startsWith('Bearer ')
    ? trimmedToken.slice('Bearer '.length).trim()
    : trimmedToken;

  if (!JWT_PATTERN.test(tokenValue)) {
    return null;
  }

  return tokenValue;
};

export const toBearerToken = rawToken => {
  const normalizedToken = normalizeAccessToken(rawToken);
  return normalizedToken ? `Bearer ${normalizedToken}` : null;
};

export const extractAccessToken = responseData => {
  const tokenCandidates = [
    responseData?.accessToken,
    responseData?.token,
    typeof responseData === 'string' ? responseData : null,
  ];

  for (const candidate of tokenCandidates) {
    const normalizedToken = normalizeAccessToken(candidate);
    if (normalizedToken) {
      return normalizedToken;
    }
  }

  return null;
};

export const extractRefreshToken = responseData => {
  const refreshToken = responseData?.refreshToken;
  return normalizeAccessToken(refreshToken);
};

export const shouldRefreshAccessToken = (token, bufferSeconds = JWT_EXP_REFRESH_BUFFER_SECONDS) => {
  const payload = parseJwtPayload(token);
  const expiration = payload?.exp;

  if (!expiration || typeof expiration !== 'number') {
    return false;
  }

  const nowInSeconds = Math.floor(Date.now() / 1000);
  return expiration <= nowInSeconds + bufferSeconds;
};
